module.exports = __webpack_public_path__ + "img/wf3.ca64fa99.png";